export default __webpack_public_path__ + "static/media/Queen_of_clubs.2a82effe.svg";